
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class OpeningBalanceDialog extends Serenity.EntityDialog<OpeningBalanceRow, any> {
        protected getFormKey() { return OpeningBalanceForm.formKey; }
        protected getIdProperty() { return OpeningBalanceRow.idProperty; }
        protected getLocalTextPrefix() { return OpeningBalanceRow.localTextPrefix; }
        protected getNameProperty() { return OpeningBalanceRow.nameProperty; }
        protected getService() { return OpeningBalanceService.baseUrl; }
        protected getDeletePermission() { return OpeningBalanceRow.deletePermission; }
        protected getInsertPermission() { return OpeningBalanceRow.insertPermission; }
        protected getUpdatePermission() { return OpeningBalanceRow.updatePermission; }
        protected useViewMode() { return true; }

        protected form = new OpeningBalanceForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.ExchRate);
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.CCAmount);
            this.form.CurrencyId.changeSelect2(e => {
                var currencyid = parseInt(this.form.CurrencyId.value);
                var x = OMS.ExchangeRateRow.getLookup().items;
                var exchrate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId == currencyid && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value);
                if (exchrate != null && exchrate.length > 0)
                    this.form.ExchRate.value = exchrate[0].ExchRate;
                else
                    this.form.ExchRate.value = 1;

            });

            this.form.ExchRate.changeSelect2(e => {

                var amount = this.form.Amount.value;
                var exchrate = this.form.ExchRate.value;
                if (amount > 0)
                    this.form.CCAmount.value = amount * exchrate;
            })
            this.form.Amount.changeSelect2(e => {
                var currencyid = this.form.CurrencyId.value;
                if (currencyid == null || currencyid == "") {
                    q.alert('', 'Please Select Currecny!', false, 2999);
                    return;
                }
                var amount = this.form.Amount.value;
                var exchrate = this.form.ExchRate.value;
                this.form.CCAmount.value = exchrate * amount;
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.CurrencyId.value != null && this.form.CurrencyId.value != "") {
                var currencyid = parseInt(this.form.CurrencyId.value);
                var exchrate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId == currencyid)[0].ExchRate;
                this.form.ExchRate.value = exchrate;
            }
        }
        // **** Get Set Toolbar Buttons **** 
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            //var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            //var oldDeleteClick = btnDelete.onClick;
            //btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            ////Edit Click Override
            //var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            ////var oldEditClick = btnEdit.onClick;
            ////btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
            ////Export PDF Button
            //btns.push(TabAurous.Common.ReportHelper.createToolButton({
            //    title: 'Print',
            //    cssClass: 'export-pdf-button',
            //    icon: 'fa fa-print text-blue',
            //    reportKey: 'Reports.PurchaseMaster',

            //    getParams: () => ({
            //        TransID: this.get_entityId()
            //    })
            //}));

            var postingpermission = Q.Authorization.hasPermission('Purchase:Invoice:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                cssClass: 'approve-doc-button',
                icon: 'fa-upload',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true;
                    delete entity.TransDate;
                    OpeningBalanceService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }

        //// #region Edit Delete Validation
        //// **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        //private confirmBeforeEdit(oldEvt, e) {
        //    //if (this.form.ItemDetails.getItems().length > 0) {
        //    //    q.showAndDisableField(this.form.PartyId);
        //    //    q.showAndDisableField(this.form.CurrencyId);
        //    //    q.showAndDisableField(this.form.ExchRate);
        //    //}

        //}

        //// **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        //private confirmBeforeDelete(oldEvt, e) {
        //    let self = this;
        //    let refid: Stock.StockItemRow;
        //    Stock.StockItemService.CheckTransaction(
        //        { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
        //        response => {
        //            if (response.Entities != null && response.Entities.length > 0)
        //                refid = response.Entities[0];
        //        }, { async: false }
        //    )
        //    if (refid != null) {
        //        if (refid.PartyId != null || refid.PartyId > 0) {
        //            Q.alert("This Voucher has been used in transactions Can Not Delete!");
        //            return;
        //        }
        //    } else {

        //        Swal.fire({
        //            title: 'Are you sure?',
        //            text: "You won't be able to revert this!",
        //            icon: 'warning',
        //            showCancelButton: true,
        //            confirmButtonColor: '#3085d6',
        //            cancelButtonColor: '#d33',
        //            confirmButtonText: 'Yes, delete it!'
        //        }).then((result) => {
        //            if (result.isConfirmed) {
        //                PurchaseMasterService.Delete(
        //                    {
        //                        EntityId: this.entityId
        //                    }, response => {
        //                        Serenity.SubDialogHelper.triggerDataChange(self);
        //                        self.dialogClose();
        //                        window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
        //                            Swal.fire({
        //                                icon: 'success',
        //                                title: 'Deleted!',
        //                                text: 'Voucher Deleted',
        //                                showConfirmButton: false,
        //                                timer: 1500
        //                            })
        //                        );
        //                    }
        //                );
        //            }
        //        })
        //    }
        //}


        // #endregion



        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('export-pdf-button').toggle(this.isEditMode());
            if (this.entity.IsPosted) {
                this.toolbar.findButton('approve-doc-button').toggle(true);
                this.form.Posted.setText("Posted");
                this.form.Posted.element.addClass("btn btn-info btn-sm");
                this.toolbar.findButton('approve-doc-button').toggle(!this.isViewMode());
            }
            else {
                this.toolbar.findButton('approve-doc-button').toggle(!this.isViewMode());
                this.form.Posted.setText("Not Posted");
                this.form.Posted.element.addClass("btn btn-warning btn-sm");
                if (this.isNew())
                    q.hideField(this.form.Posted);
            }

        }
    }
}